import Interceptor from "@/plugins/interceptor.js";

const urlAPI = `${process.env.VUE_APP_API_URL}${process.env.VUE_APP_API_TICKET}`;

const Game = {
  state: {
    tickets: [],
    subscriptions: []
  },
  actions: {
    generateTicketLot: async ({}, model) => {
      try {
        const response = await Interceptor.post(`${urlAPI}/generateTicketLot`, model)
        return response
      } catch (error) {
        console.error(error)
      }
    }, 
    ticketLotGet: async ({commit}, params) => {
      try {
        const response = await Interceptor.get(`${urlAPI}/ticketLotGet?gameId=${params.gameId}`)
        commit("SET_tickets", response.data)
        return response
      } catch (error) {
        console.error(error)
      }
    },
    ticketLotGetById: async ({}, params) => {
      try {
        const response = await Interceptor.get(`${urlAPI}/ticketLotGetById?ticketLotId=${params.ticketLotId}`)
        return response
      } catch (error) {
        console.error(error)
      }
    },
    ticketLotDelete: async ({}, model) => {
      try {
        const response = await Interceptor.delete(`${urlAPI}/ticketLotDelete`, model)
        return response
      } catch (error) {
        console.error(error)
      }
    },
    generateSubscriptionLot: async ({}, model) => {
      try {
        const response = await Interceptor.post(`${urlAPI}/generateSubscriptionLot`, model);
        return response;
      } catch (error) {
        console.error(error);
      }
    },
    subscriptionLotGet: async ({commit}) => {
      try {
        const response = await Interceptor.get(`${urlAPI}/SubscriptionLotGet`);
        commit("SET_subscriptions", response.data)
        return response;
      } catch (error) {
        console.error(error);
      }
    },
    subscriptionLotGetById: async ({}, params) => {
      try {
        const response = await Interceptor.get(`${urlAPI}/subscriptionLotGetById?id=${params.id}`)
        return response
      } catch (error) {
        console.error(error);
      }
    },
    subscriptionLotDelete: async ({}, model) => {
      try {
        const response = await Interceptor.delete(`${urlAPI}/SubscriptionLotDelete`, model);
        return response;
      } catch (error) {
        console.error(error);
      }
    },
    ticketMatchdayReport: async ({}, params) => {
      try {
        const response = await Interceptor.get(`${urlAPI}/ticketMatchdayReport?seasonId=${params.seasonId}&matchday=${params.matchday}`)
        return response
      } catch (error) {
        console.error(error);
      }
    }
  },
  mutations: {
    SET_tickets (state, value) {
      state.tickets = value
    },
    SET_subscriptions (state, value) {
      state.subscriptions = value
    }
  }
};

export default Game;